module.exports = __webpack_public_path__ + "video/poldi_first.mp4";